export const boathouse = {
  name: 'Boathouse',
  subtitle: 'Tiki Bar & Grill',
  slug: '/projects/boathouse',
  status: 'In development',
  location: 'Southwest Florida',
  website: 'https://www.theboathouseusa.com/',
  tagline:
    'A new waterfront home for Boat House Tiki Bar & Grill — dock your boat, grab a seat under the palapa and stay for the sunset.',
  intro:
    'Sinclair is developing a new Boat House location built around the water: an open-air tiki bar under a thatched palapa roof, a waterfront dining deck, an indoor dining room that opens to the canal, and boat slips so guests can arrive by water.',
  features: [
    'Open-air thatched tiki bar',
    'Waterfront dining deck',
    'Boat slips & day dock',
    'Indoor dining room',
    'Live music stage',
    'Sunset views on the canal',
  ],
  heroImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/73234e70-23d3-4384-865f-72039e5f1768.jpg',
}

export const boathousePhotos = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4c084573-ebfb-4b97-8525-6c3e61f8b0e9.jpg',
    title: 'Site from above',
    caption: 'Restaurant, dock and parking on the canal.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ccd766e4-1fac-4b53-93f0-d6d0951ce51c.jpg',
    title: 'The tiki bar',
    caption: 'An open-air bar under a thatched palapa roof.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/3cbb4410-9695-4189-bb93-be8e78724786.jpg',
    title: 'Dining deck & dock',
    caption: 'Waterfront tables with boat slips alongside.',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/615db402-7f03-44f6-af62-2129f61e59c1.jpg',
    title: 'Dining room',
    caption: 'Roll-up glass doors open the room to the water.',
  },
]
